import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Checkbox, FormControlLabel } from "@mui/material";

import { ColumnContainer } from "../../utils/columnsStyle";

import {
  deselectNoteToFiscalUpdate,
  selectNoteToFiscalUpdate,
} from "../../redux/actions/notesFiscalUpdate/notesFiscalUpdateActions";

export const columns = [
  {
    Header: "Folio",
    accessor: "folio",
    filterable: true,
  },
  {
    Header: "Cliente",
    accessor: "customer",
    filterable: true,
    filterMethod: (filter, row) => row.customer?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Cuenta",
    accessor: "account",
    filterable: true,
    filterMethod: (filter, row) => row.account?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Fecha",
    accessor: "date",
    filterable: true,
    filterMethod: (filter, row) => row.date?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Tipo",
    accessor: "type",
    filterable: true,
    filterMethod: (filter, row) => row.type?.toLowerCase().includes(filter.value.toLowerCase()),
  },
  {
    Header: "Total",
    accessor: "total",
    filterable: true,
  },
  {
    Header: "Acciones",
    filterable: false,
    sortable: false,
    Cell: ({ original }) => {
      const dispatch = useDispatch();
      const { notesToFiscalUpdate } = useSelector(({ notesFiscalUpdate }) => notesFiscalUpdate);
      const { id } = original;
      const isFiscalUpdate = notesToFiscalUpdate?.has(id);

      const handleIsFiscalUpdate = () => {
        if (isFiscalUpdate) dispatch(deselectNoteToFiscalUpdate(id));
        else dispatch(selectNoteToFiscalUpdate(id));
      };

      return (
        <ColumnContainer>
          <FormControlLabel
            control={
              <Checkbox
                color="success"
                checked={isFiscalUpdate}
                onChange={handleIsFiscalUpdate}
                name="migrate"
                size="small"
                sx={{
                  color: "rgb(246,110,94)",
                  "&.Mui-checked": {
                    color: "rgb(98, 212, 102)",
                  },
                }}
              />
            }
            label="Actualizar"
          />
        </ColumnContainer>
      );
    },
  },
];
